import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { DTFService } from "../../dtf.service";
import { AuthorizationService } from "../authorization/authorization.service";
import { WindowRef } from '../../utils/window';

import { APP_CONSTANTS } from '../../utils/app-constants';
import { TranslateUtil } from '../../utils/translate-util';
import { DTFHomepageService } from "../dtfhomepage/dtfhomepage.service";
import { Banner } from "../../shared/models/banner";
import { FormBuilder, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { SharedTranslateModule } from "../../utils/sharedTranslateModule";
import { DynamicLeaseFormComponent } from "../dynamicleaseform/dynamicleaseform.component";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { DynamicAddendumResponse } from '../../shared/models/dynamicAddendumResponse';
import * as d3 from 'd3';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DynamicAddendumTotalsRecord } from '../../shared/models/dynamicAddendumTotalResponse';
import { Subscription, fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SessionTimeoutComponent } from '../sessionTimeout/sessionTimeout.component';


@Component({
    selector: "div.dtf-dynamicdashboardpage",
    imports: [SharedTranslateModule,
        MatPaginator, MatSort, MatTableModule, MatCheckboxModule, MatFormFieldModule,SessionTimeoutComponent,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatNativeDateModule,
        MatDatepickerModule, MatIconModule, MatDialogModule, MatButtonModule,
        MatSortModule, MatTooltipModule
    ],
    templateUrl: './dynamicdashboard.component.html',
    providers: [
    //  ClassesUtil, WindowRef
    ]
})
export class DynamicDashboardComponent implements OnInit {
  router: Router;
  isCanadaPortal = false;
  currentCountry: string;
  language = '';
  targetRedirect = '';
  usUrl: string;
  caUrl: string;
  token: string;
  ciamId = sessionStorage.getItem('loginID');
  thirdPartyNumber: string;
  accountNumber: string;
  toggleOpen: any;
  public alerts: Banner;
  dbData: any;
  dynamicAddendumRes: DynamicAddendumResponse[];
  dynamicAddendumTotalsRecords: DynamicAddendumTotalsRecord[];

  dataSource: MatTableDataSource<DynamicAddendumResponse>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dbLoaded = false;
  mileageFee = 0;
  baseFee = 0;
  totalFee = 0;
  currentTotalRental=0;
  currentOverageCharges=0;
  mileagePercentage="";
  baseFeePercentage="";
  totalOverage=0;
  totalRental=0;
  mileageRate=0;
  azURL: string;
  latestInvoiceMonth: Date | null = null;
  latestInvoiceMonthStr: string = '';  // MM/DD/YYYY format
  totalPrevUnusedAllowance: string = '0';
  totalMilesAvailableForRebating: string = '0';
  localDueDate: Date | null = null;

  statementMonths: { value: Date; display: string }[] = [];
  selectedMonth!: { value: Date; display: string };
  formattedDate: string = '';

  displayPercentage = false;
  @ViewChild('donutChart', { static: true }) donutChartContainer: ElementRef;
  @ViewChild('barChart', { static: true }) private barChartContainer: ElementRef;
  
  private resizeSubscription!: Subscription;
  private dataLoaded = false; // track if data is loaded

  private barChartResizeObserver: ResizeObserver | null = null;

    // Table columns
    initColumns: any[] = [
      {
        name: 'vin',
        display: 'VIN',
        displayFR: 'Numéro de contrat',
        dispFormat: 'vin'
      },
      {
        name: 'periodAllowedMileage',
        display: 'Allowance',
        displayFR: 'Dernier paiement reçu',
        dispFormat: 'numbers'
      },
      {
        name: 'previousReading',
        display: 'Initial Reading',
        displayFR: 'Type de contrat',
        dispFormat: 'numbers'
      },
      {
        name: 'odometerReading',
        display: 'Current Reading',
        displayFR: 'Current Reading',
        dispFormat: 'numbers'
      },
      {
        name: 'odometerReadingDateNK',
        display: 'Reading Date',
        displayFR: 'Reading Date',
        dispFormat: 'date'
      },
      {
        name: 'currPeriodOverUnder',
        display: 'Status',
        displayFR: 'Status',
        dispFormat: 'currPeriodOverUnder'
      },
      {
        name: 'adjustedBalloon',
        display: 'AB / RV',
        displayFR: '',
        dispFormat: 'currency',
        tooltip: 'Adjusted Balloon / Residual Value'
      },
      {
        name: 'compYrNK',
        display: 'More Info',
        displayFR: '',
        dispFormat: 'none'
      }
    //  {
    //     name: 'status',
    //     display: 'Status',
    //     displayFR: 'Statu',
    //     dispFormat: ''
    //   }
    ];
    displayedColumns: any[] = this.initColumns.map(col => col.name);
  
    filterActive = false;
    filter = false;
    rowCount = 0;
    value = '';

  data: { category: string, stack1: number, stack2: number }[] = [];

  constructor(
    router: Router,
    public translate: TranslateService,
    private _window: WindowRef,
    public dtfhomepageService: DTFHomepageService,
    public translateUtil: TranslateUtil,
    public auth: AuthorizationService,
    public dialog: MatDialog
  ) {
    this.router = router;
    this.dynamicAddendumRes =[];
    this.dynamicAddendumTotalsRecords = [];
    this.dataSource = new MatTableDataSource(this.dynamicAddendumRes);

}

  ngOnInit() {
    const language = (window as any).mbfs.language;
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
    });
    this.getAlerts();
    this.langInit();
    this.token = sessionStorage.getItem('ciamToken');
    this.accountNumber = sessionStorage.getItem('amortAccount').toString().slice(0, -3);
    this.thirdPartyNumber = sessionStorage.getItem('thirdPartyNumber');
    const now = new Date();
  this.generateStatementMonths();
  this.selectedMonth = this.statementMonths[0];
  this.formattedDate = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    year: 'numeric',
  }).format(this.selectedMonth.value);
  this.fetchDynamicData(); // will use selectedMonth
    }

fetchDynamicData() {
  const statementDate = this.formatDateYYYYMMDD(this.selectedMonth?.value);

  const dynamicAddendumRequest = {
    ciamId: this.ciamId,
    ciamAZCode: this.token,
    ccanId: this.thirdPartyNumber,
    contractNumber: this.accountNumber,
    statementDate: statementDate
  };

  this.auth.dynamicAddendum(dynamicAddendumRequest).subscribe(res => {
    this.dynamicAddendumRes = res.dynamicAddendumRecords;
    this.dynamicAddendumTotalsRecords = res.dynamicAddendumTotalsRecords;

    console.log('Fetched dynamicAddendumRes:', JSON.stringify(this.dynamicAddendumRes));
    // Get invoice records for the selected month
    const matchingRecords = this.getInvoiceRecordsForSelectedMonth(res);

    // Update UI-related fields
    this.mileageRate = parseFloat(res.dynamicAddendumRecords[0]?.mileageRate || '0');
    this.totalOverage = parseFloat(parseFloat(res.currentTotalRental).toFixed(2));
    this.totalRental = parseFloat(parseFloat(res.currentOverageCharges).toFixed(2));

    // Calculate totals for selected month (now that data is ready)
    this.calculateSelectedMonthTotals();

    // Update your table datasource with these records
    console.log('Setting dataSource with records:', JSON.stringify(matchingRecords));
    this.dataSource = new MatTableDataSource(matchingRecords);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.rowCount = this.dataSource.filteredData.length;

    // Prepare charts
    this.prepareChartData();
    this.createDonutChart();
    this.createBarChart();
  });
}

  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  langInit() {
    // Initializes Language and all URL's for href
    this.language = (this._window.nativeWindow as any).mbfs.language;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
  }

  getAlerts() {
    this.dtfhomepageService.getAlerts().subscribe((res) => {
        for (var i = 0; i < res.length; i++) {
          if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
            this.alerts = res[i];
            this.dbData = true;
          }
        }
      });
  }
getInvoiceRecordsForSelectedMonth(res: any): any[] {
  const records = res?.dynamicAddendumRecords ?? [];
  console.log('All Records:', JSON.stringify(records));
  if (records.length === 0 || !this.selectedMonth?.value) return [];

  const selected = new Date(this.selectedMonth.value);
  const selectedMonth = selected.getMonth();
  const selectedYear = selected.getFullYear();

  // Step 1: Filter for valid records with valid dates
  const validRecords = records.filter(record => {
    const dateStr = record?.dynamicIdentity?.invoiceIssueDate;
    const date = new Date(dateStr);
    return !!dateStr && !isNaN(date.getTime());
  });
  console.log('validRecords:', JSON.stringify(validRecords));
  if (validRecords.length === 0) return [];

  // Step 2: Filter records that match selected month and year
  const matchingRecords = validRecords.filter(record => {
    const recordDate = new Date(record.dynamicIdentity.invoiceIssueDate);
    return (
      recordDate.getMonth() === selectedMonth &&
      recordDate.getFullYear() === selectedYear
    );
  });

  // Setting Values for the Donut Chart top by pulling first record in list
  if (matchingRecords.length > 0) {
    const firstMatch = new Date(matchingRecords[0].dynamicIdentity.invoiceIssueDate);
    this.latestInvoiceMonth = firstMatch;
    this.latestInvoiceMonthStr = this.formatDateMMDDYYYY(firstMatch);
  }

  console.log('matchingRecords:', JSON.stringify(matchingRecords));
  return matchingRecords;
}


prepareChartData(): void {
  const now = new Date();

  // Change startDate to 11 months before current month, keeping day 1 (start of month)
  const startDate = new Date(now.getFullYear(), now.getMonth() - 11, 1); // e.g., Aug 1, 2024

  // Change endDate to last day of current month (not start)
  const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);    // e.g., Aug 31, 2025

  const monthlyTotals: { [key: string]: { stack1: number; stack2: number } } = {};

  // Pre-fill months from current month backward 12 months
  for (let i = 0; i < 12; i++) {
    const date = new Date(endDate.getFullYear(), endDate.getMonth() - i, 1);
    const key = `${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear().toString().slice(-2)}`; // e.g., 'Aug 25'
    monthlyTotals[key] = { stack1: 0, stack2: 0 };
  }

  this.dynamicAddendumTotalsRecords.forEach(record => {
    const invoiceDate = new Date(record.invoiceDate);
    if (invoiceDate >= startDate && invoiceDate <= endDate) {
      const key = `${invoiceDate.toLocaleString('default', { month: 'short' })} ${invoiceDate.getFullYear().toString().slice(-2)}`;
      if (monthlyTotals[key]) {
        monthlyTotals[key].stack1 += record.overageCharges || 0;
        monthlyTotals[key].stack2 += record.totalRental || 0;
      }
    }
  });

  // Convert to chart data
  this.data = Object.entries(monthlyTotals).map(([category, { stack1, stack2 }]) => ({
    category,
    stack1: +stack1.toFixed(2),
    stack2: +stack2.toFixed(2),
  }));
}



calculateSelectedMonthTotals(): void {
  if (!this.selectedMonth?.value) return;

  const selectedDate = new Date(this.selectedMonth.value);
  const startDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
  const endDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0);

  const filteredItems = this.dynamicAddendumRes.filter(item => {
    const readingDate = new Date(item.odometerReadingDateNK);
    return readingDate >= startDate && readingDate <= endDate;
  });

  const totals = filteredItems.reduce(
    (acc, item) => {
      const prevUnused = parseFloat(item.prevUnusedAllowance || '0');
      const milesRebating = parseFloat(item.milesAvailableForRebating || '0');

      acc.prevUnusedAllowance += isNaN(prevUnused) ? 0 : prevUnused;
      acc.milesAvailableForRebating += isNaN(milesRebating) ? 0 : milesRebating;

      return acc;
    },
    { prevUnusedAllowance: 0, milesAvailableForRebating: 0 }
  );

  this.totalPrevUnusedAllowance = totals.prevUnusedAllowance.toLocaleString('en-US');
  this.totalMilesAvailableForRebating = totals.milesAvailableForRebating.toLocaleString('en-US');
}


createDonutChart(): void {
  const container = d3.select(this.donutChartContainer.nativeElement);
  container.selectAll('*').remove();  // Clear previous chart

  const base = Math.max(0, Number(this.totalRental) || 0);
  const mileage = Math.max(0, Number(this.totalOverage) || 0);
  const total = base + mileage;

  const formattedBase = base.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const formattedMileage = mileage.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const formattedTotal = total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  this.totalFee = total || 1;

  this.baseFee = total && base ? base / total : 0;
  this.mileageFee = total && mileage ? mileage / total : 0;
  this.baseFeePercentage = `${Math.round(this.baseFee * 100)}%`;
  this.mileagePercentage = `${Math.round(this.mileageFee * 100)}%`;

  const data = [base, mileage];
  const colors = ['#cce1e6', '#5097ab']; // [Base, Mileage]

  const containerWidth = this.donutChartContainer.nativeElement.offsetWidth || 300;
  const containerHeight = this.donutChartContainer.nativeElement.offsetHeight || 300;
  const margin = 20;
  const radius = Math.min(containerWidth, containerHeight) / 2 - margin;

  d3.select(this.donutChartContainer.nativeElement).html('');

  const svg = d3.select(this.donutChartContainer.nativeElement)
    .append('svg')
    .attr('viewBox', `0 0 ${containerWidth} ${containerHeight}`)
    .attr('preserveAspectRatio', 'xMidYMid meet')
    .style('width', '100%')
    .style('height', '100%')
    .append('g')
    .attr('transform', `translate(${containerWidth / 2}, ${containerHeight / 2})`);

  const arc = d3.arc()
    .innerRadius(radius - 40)
    .outerRadius(radius - 10);

  const pie = d3.pie()
    .sort(null)
    .value((d: any) => d);

  const arcs = svg.selectAll('.arc')
    .data(pie(data))
    .enter()
    .append('g')
    .attr('class', 'arc');

  arcs.append('path')
    .attr('d', arc)
    .attr('fill', (d, i) => colors[i])  // ✅ FIXED: use direct color array
    .attr('stroke', '#fff')
    .attr('stroke-width', 1.5);

  // Center label
  svg.append('text')
    .attr('text-anchor', 'middle')
    .attr('font-size', '24px')
    .attr('fill', '#000')
    .attr('dy', '0.3em')
    .text(`$${formattedTotal}`)
    .append('title')
    .text('Base Payment + Mileage Fee');

  this.displayPercentage = true;
}

createBarChart(): void {
  const element = this.barChartContainer.nativeElement;
  const margin = { top: 20, right: 30, bottom: 60, left: 80 };

  const svgWidth = element.offsetWidth - margin.left - margin.right;
  const svgHeight = element.offsetHeight - margin.top - margin.bottom;

  // Clear previous chart if any
  d3.select(element).selectAll('*').remove();

  // Tooltip
  const tooltip = d3.select(element)
    .append('div')
    .style('position', 'absolute')
    .style('padding', '6px 10px')
    .style('background', 'rgba(0, 0, 0, 0.75)')
    .style('color', '#fff')
    .style('border-radius', '4px')
    .style('font-size', '12px')
    .style('pointer-events', 'none')
    .style('visibility', 'hidden');
    
  // Sanitize data
  const safeData = this.data.map(d => ({
    category: d.category,
    stack1: Math.max(0, Number(d.stack1) || 0),
    stack2: Math.max(0, Number(d.stack2) || 0)
  }));

  const maxX = d3.max(safeData, d => d.stack1 + d.stack2) || 100;

  // SVG setup
  const svg = d3.select(element)
    .append('svg')
    .attr('width', '100%')
    .attr('height', '100%')
    .attr('viewBox', `0 0 ${svgWidth + margin.left + margin.right} ${svgHeight + margin.top + margin.bottom}`)
    .attr('preserveAspectRatio', 'xMinYMin meet');

  const g = svg.append('g')
    .attr('transform', `translate(${margin.left}, ${margin.top})`);

  // Scales
  const yScale = d3.scaleBand()
    .domain(safeData.map(d => d.category))
    .range([0, svgHeight])
    .padding(0.1);

  const xScale = d3.scaleLinear()
    .domain([0, maxX])
    .nice()
    .range([0, svgWidth]);

  // Draw stack2 first (x=0)
  g.selectAll('.stack2')
    .data(safeData)
    .enter()
    .append('rect')
    .attr('class', 'stack2')
    .attr('x', 0)
    .attr('y', d => yScale(d.category)!)
    .attr('width', d => xScale(d.stack2))
    .attr('height', yScale.bandwidth())
    .attr('fill', '#5097ab')
    .on('mouseover', (event: MouseEvent, d) => {
      tooltip
        .style('visibility', 'visible')
        .html(`<strong>Base Payment:</strong> $${d.stack2.toLocaleString()}`);
      d3.select(event.currentTarget as SVGRectElement).attr('opacity', '0.8');
    })
    .on('mousemove', (event: MouseEvent) => {
      const [x, y] = d3.pointer(event, element);
      tooltip
        .style('top', `${y - 40}px`)
        .style('left', `${x + 15}px`);
    })
    .on('mouseout', (event: MouseEvent) => {
      tooltip.style('visibility', 'hidden');
      d3.select(event.currentTarget as SVGRectElement).attr('opacity', '1');
    });

  // Draw stack1 second (x = stack2 width)
  g.selectAll('.stack1')
    .data(safeData)
    .enter()
    .append('rect')
    .attr('class', 'stack1')
    .attr('x', d => xScale(d.stack2))
    .attr('y', d => yScale(d.category)!)
    .attr('width', d => xScale(d.stack1))
    .attr('height', yScale.bandwidth())
    .attr('fill', '#cce1e6')
    .on('mouseover', (event: MouseEvent, d) => {
      tooltip
        .style('visibility', 'visible')
        .html(`<strong>Mileage Fee:</strong> $${d.stack1.toLocaleString()}`);
      d3.select(event.currentTarget as SVGRectElement).attr('opacity', '0.8');
    })
    .on('mousemove', (event: MouseEvent) => {
      const [x, y] = d3.pointer(event, element);
      tooltip
        .style('top', `${y - 40}px`)
        .style('left', `${x + 15}px`);
    })
    .on('mouseout', (event: MouseEvent) => {
      tooltip.style('visibility', 'hidden');
      d3.select(event.currentTarget as SVGRectElement).attr('opacity', '1');
    });

  // Axes
  g.append('g')
    .call(d3.axisTop(xScale)
      .ticks(5)
      .tickFormat(d3.format('.0s')))
    .selectAll('text')
    .style('fill', 'black')
    .style('font-size', '12px');

  g.append('g')
    .call(d3.axisLeft(yScale))
    .selectAll('text')
    .style('fill', 'black')
    .style('font-size', '12px');

  // Average line
  const average = d3.mean(safeData, d => d.stack1 + d.stack2) || 0;

  g.append('line')
    .attr('x1', xScale(average))
    .attr('y1', 0)
    .attr('x2', xScale(average))
    .attr('y2', svgHeight)
    .attr('stroke', 'black')
    .attr('stroke-width', 2)
    .attr('stroke-dasharray', '5,5')
    .style('cursor', 'pointer')
    .on('mouseover', () => {
      tooltip
        .style('visibility', 'visible')
        .html(`<strong>Average:</strong> $${average.toFixed(2)}`);
    })
    .on('mousemove', (event: MouseEvent) => {
      const [x, y] = d3.pointer(event, element);
      tooltip
        .style('top', `${y - 40}px`)
        .style('left', `${x + 15}px`);
    })
    .on('mouseout', () => {
      tooltip.style('visibility', 'hidden');
    });

  // Legend
  const legend = g.append('g')
    .attr('transform', `translate(0, ${svgHeight + 40})`);

  const legendItems = [
    { type: 'line', label: 'Average', color: 'black', dash: '5,5' },
    { type: 'rect', label: 'Base', color: '#5097ab' },
    { type: 'rect', label: 'Mileage Fee', color: '#cce1e6' }
  ];

  const spacing = svgWidth / legendItems.length;

  legendItems.forEach((item, i) => {
    const xOffset = i * spacing;

    if (item.type === 'line') {
      legend.append('line')
        .attr('x1', xOffset)
        .attr('y1', 10)
        .attr('x2', xOffset + 20)
        .attr('y2', 10)
        .attr('stroke', item.color)
        .attr('stroke-width', 2)
        .attr('stroke-dasharray', item.dash);

      legend.append('text')
        .attr('x', xOffset + 25)
        .attr('y', 15)
        .text(item.label)
        .style('fill', 'black')
        .style('font-size', '12px');
    } else {
      legend.append('rect')
        .attr('x', xOffset)
        .attr('y', 0)
        .attr('width', 20)
        .attr('height', 20)
        .attr('fill', item.color);

      legend.append('text')
        .attr('x', xOffset + 25)
        .attr('y', 15)
        .text(item.label)
        .style('font-size', '12px')
        .style('fill', '#333');
    }
  });
}

isReadingMissing(value: any): boolean {
  const isNullOrUndefined = value === null || value === undefined;
  const isEmptyString = typeof value === 'string' && value.trim() === '';

  return isNullOrUndefined || isEmptyString;
}
  getAllowanceStatus(value: any): 'over' | 'under' {
  if (value == null) return 'under';
  // Remove commas and convert to number
  const numericValue = +value.toString().replace(/,/g, '');
  return numericValue > 0 ? 'over' : 'under';
}
  openDialog(vin: any): void {
      sessionStorage.setItem('AssetSelected', vin );
      let dialogRef = this.dialog.open(DylDashboardDialogComponent, {
        maxWidth: '200vw',
        width: '400px',
        position: { right: '0', top: '0' },
        panelClass: 'slide-in-dialog',
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
      });
  }

  backstep() {
    this.azURL = this.usUrl + '/home/accountdetails';
    setTimeout(() => {
      this._window.nativeWindow.location.href = this.azURL;
    }, 1000);

  }

ngAfterViewInit() {
  this.resizeSubscription = fromEvent(window, 'resize')
    .pipe(debounceTime(200))
    .subscribe(() => {
      if (this.dataLoaded) {
        this.createDonutChart();
      }
    });

  this.observeBarChartContainer();

  // Force chart render on init when view is ready
  setTimeout(() => {
    if (this.dataLoaded) {
      this.createBarChart(); // <-- forces first-time render on mobile
    }
  }, 0);
}

formatDateMMDDYYYY(date: Date): string {
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
}
formatDateYYYYMMDD(date: Date): string {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = '04'; // fixed day as per your requirement
  return `${yyyy}-${mm}-${dd}`;
}


 generateStatementMonths(): void {
    const now = new Date();

    for (let i = 0; i < 12; i++) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const display = new Intl.DateTimeFormat('en-US', {
        month: 'short', // "Aug"
        year: 'numeric',
      }).format(date); // e.g., "Aug 2025"

      this.statementMonths.push({
        value: date,
        display: display,
      });
    }
  }

onStatementChange(){
  this.formattedDate = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    year: 'numeric',
  }).format(this.selectedMonth.value);

  this.fetchDynamicData();
}


ngOnDestroy() {
  if (this.resizeSubscription) {
    this.resizeSubscription.unsubscribe();
  }
  if (this.barChartResizeObserver) {
    this.barChartResizeObserver.disconnect();
  }
}

private observeBarChartContainer(): void {
  const element = this.barChartContainer.nativeElement;

  this.barChartResizeObserver = new ResizeObserver(entries => {
    for (const entry of entries) {
      const width = entry.contentRect.width;
      const height = entry.contentRect.height;

      if (width > 100 && height > 100 && this.dataLoaded) {
        this.createBarChart();
      }
    }
  });

  this.barChartResizeObserver.observe(element);
}
}


@Component({
    selector: 'dialog-DylDashboardPopup',
    imports: [
        MatPaginator, MatPaginatorModule, MatSortModule, MatTableModule, MatCheckboxModule, MatFormFieldModule, MatDialogModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatButtonModule, MatSortModule,
        MatDialogContent, MatDialogActions
    ],
    providers: [DatePipe],
    templateUrl: 'DylDashboardDialog.component.html'
})
export class DylDashboardDialogComponent {
  usUrl: string;
  caUrl: string;
  payoffdialog: string;
  errorMessage: string;
  dbLoaded = false;
  filterActive = false;
  hideError = false;
  filter = false;
  accountNumber: string;
  assetSelected: string;
  ciamId:string;
  thirdPartyNumber: string;
  residualTotal: string = '0';

  token:string;
  statusMessage = "";
  rowCount = 0;
  value = '';

  tableLoaded = true;

  dynamicAddendumRes: DynamicAddendumResponse[];
  dataSource: MatTableDataSource<DynamicAddendumResponse>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

initColumns: any[] = [  
      {
        name: 'odometerReadingDateNK',
        display: 'Reading Date',
        displayFR: 'Reading Date',
        dispFormat: 'date'
      },
      {
        name: 'odometerReading',
        display: 'Current Reading',
        displayFR: 'Current Reading',
        dispFormat: 'numbers'
      },

];

  displayedColumns: any[] = this.initColumns.map(col => col.name);
  
  constructor(router: Router, private dtfhomepageService: DTFHomepageService, private fb: FormBuilder, public auth: AuthorizationService,
    private _window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil, public dialog: MatDialog,
    public dialogRef: MatDialogRef<DylDashboardDialogComponent>,public datePipe: DatePipe

  ) {
      this.token = sessionStorage.getItem('ciamToken');
      this.thirdPartyNumber = sessionStorage.getItem('thirdPartyNumber');
      this.accountNumber = sessionStorage.getItem('amortAccount').toString().slice(0, -3);
      this.assetSelected = sessionStorage.getItem('AssetSelected');
      this.ciamId = sessionStorage.getItem('loginID');
      this.dynamicAddendumRes =[];
      this.dataSource = new MatTableDataSource(this.dynamicAddendumRes);
      this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
      this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;

        this.tableLoaded = false;
        this.dynamicAddendumRes = [];
        const dynamicAddendumRequest = {
          ciamId : this.ciamId ,
          ciamAZCode :this.token,
          ccanId : this.thirdPartyNumber,
          contractNumber : this.accountNumber,
          assetId : this.assetSelected
        };

      this.auth.fetchDynamicAddendumAssetHistory(dynamicAddendumRequest).subscribe(res => {
        this.statusMessage = res.statusMessage;
        this.dynamicAddendumRes = res.dynamicAddendumRecords;
        this.residualTotal = res.residualTotal;
        this.dataSource = new MatTableDataSource(this.dynamicAddendumRes);
        this.tableLoaded = true;

      setTimeout(()=>{
        this.dbLoaded = true;
        this.filter = true;
        this.rowCount = this.dataSource.filteredData.length;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
   });
  });
  }


  closeDialog(code: any) {
    this.dialog.closeAll();
  }

  payoffRedirect(e: Event) {
    let redirect = '';
    window.location.href = redirect;
  }

  toSafeNumber(value: any): number {
  const num = Number(value);
  return isNaN(num) ? 0 : num;
}

formatNumber(value: any): string {
  return this.toSafeNumber(value).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

  formatDate(dateString: string) {
    if (!dateString) return '';
    return this.datePipe.transform(dateString, 'MM/dd/yyyy') || '';
  }
}
